import { Star } from "lucide-react";

// 1-5 star rating. Click a star to set; click the same star again to clear.
export const StarRating = ({ value, onChange, testid }) => {
  const rating = Number(value) || 0;
  return (
    <div className="flex h-10 items-center gap-1" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          onClick={() => onChange(rating === n ? null : n)}
          data-testid={`${testid}-${n}`}
          className="transition-transform duration-150 hover:scale-110"
          aria-label={`${n} star${n > 1 ? "s" : ""}`}
        >
          <Star
            className={`h-6 w-6 ${n <= rating ? "fill-amber-400 text-amber-400" : "text-zinc-600"}`}
          />
        </button>
      ))}
      {rating > 0 && <span className="ml-2 text-sm text-zinc-300">{rating}/5</span>}
    </div>
  );
};
